import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  * + ", " {\n    ", "\n  }\n  * + ", " {\n    ", "\n  }\n  * + ", " {\n    ", "\n  }\n  * + ", " {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Base, Big, ExtraSmall, H5, Small } from '../../Typography';
import { ICON_SIZE, INFO_WITH_ICONS_SMALL_MARGIN } from '../../constants';
import { ELEMENT_GRAY } from '../../colors';
import { EMPTY_PROPS } from '../../helpers/types';
import InfoContentSimple from '../InfoContent/InfoContentSimple';
import InfoContentWithIconSimple from '../InfoContent/InfoContentWithIconSimple';
import { marginTop } from '../../style/margin-top';
var MARGIN_SMALL = {
  small: {
    xs: 0,
    lg: 2
  },
  medium: {
    xs: 2,
    lg: 4
  },
  large: {
    xs: 4,
    lg: 8
  }
};
var MARGIN_BASE = {
  small: {
    xs: 2,
    md: 4
  },
  medium: {
    xs: 3,
    md: 6
  },
  large: {
    xs: 6,
    md: 8,
    xl: 10
  }
};
var MARGIN_BIG = {
  small: {
    xs: 0,
    sm: 2
  },
  medium: {
    xs: 2,
    sm: 4
  },
  large: {
    xs: 4,
    sm: 8
  }
};
var ContentWrapper = styled.div(_templateObject(), function (_ref) {
  var $fullWidth = _ref.$fullWidth;
  return $fullWidth ? "width: 100%;" : '';
}, function (_ref2) {
  var $withOverflowHidden = _ref2.$withOverflowHidden;
  return $withOverflowHidden ? "overflow: hidden;" : '';
}, ExtraSmall, function (_ref3) {
  var _ref3$$size = _ref3.$size,
      $size = _ref3$$size === void 0 ? 'medium' : _ref3$$size;
  return marginTop(MARGIN_SMALL[$size] || MARGIN_SMALL.medium);
}, Small, function (_ref4) {
  var _ref4$$size = _ref4.$size,
      $size = _ref4$$size === void 0 ? 'medium' : _ref4$$size;
  return marginTop(MARGIN_SMALL[$size] || MARGIN_SMALL.medium);
}, Base, function (_ref5) {
  var _ref5$$size = _ref5.$size,
      $size = _ref5$$size === void 0 ? 'medium' : _ref5$$size;
  return marginTop(MARGIN_BASE[$size] || MARGIN_BASE.medium);
}, Big, function (_ref6) {
  var _ref6$$size = _ref6.$size,
      $size = _ref6$$size === void 0 ? 'medium' : _ref6$$size;
  return marginTop(MARGIN_BIG[$size] || MARGIN_BASE.medium);
});

var InfoCardContent = function InfoCardContent(_ref7) {
  var textAlign = _ref7.textAlign,
      _ref7$withOverflowHid = _ref7.withOverflowHidden,
      withOverflowHidden = _ref7$withOverflowHid === void 0 ? true : _ref7$withOverflowHid,
      _ref7$fullWidth = _ref7.fullWidth,
      fullWidth = _ref7$fullWidth === void 0 ? true : _ref7$fullWidth,
      _ref7$fixedHeight = _ref7.fixedHeight,
      fixedHeight = _ref7$fixedHeight === void 0 ? true : _ref7$fixedHeight,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 'medium' : _ref7$size,
      bodyTitle = _ref7.bodyTitle,
      bodyIcon = _ref7.bodyIcon,
      _ref7$bodyLines = _ref7.bodyLines,
      bodyLines = _ref7$bodyLines === void 0 ? 1 : _ref7$bodyLines,
      _ref7$bodyProps = _ref7.bodyProps,
      bodyProps = _ref7$bodyProps === void 0 ? EMPTY_PROPS : _ref7$bodyProps,
      _ref7$titleLines = _ref7.titleLines,
      titleLines = _ref7$titleLines === void 0 ? 1 : _ref7$titleLines,
      title = _ref7.title,
      _ref7$titleProps = _ref7.titleProps,
      titleProps = _ref7$titleProps === void 0 ? EMPTY_PROPS : _ref7$titleProps,
      _ref7$titleAs = _ref7.titleAs,
      titleAs = _ref7$titleAs === void 0 ? 'p' : _ref7$titleAs,
      kickerTitle = _ref7.kickerTitle,
      _ref7$kickerProps = _ref7.kickerProps,
      kickerProps = _ref7$kickerProps === void 0 ? EMPTY_PROPS : _ref7$kickerProps,
      kickerPrefix = _ref7.kickerPrefix,
      kickerSuffix = _ref7.kickerSuffix,
      kickerColor = _ref7.kickerColor,
      _ref7$kickerAs = _ref7.kickerAs,
      kickerAs = _ref7$kickerAs === void 0 ? 'p' : _ref7$kickerAs,
      subTitle = _ref7.subTitle,
      _ref7$subTitleProps = _ref7.subTitleProps,
      subTitleProps = _ref7$subTitleProps === void 0 ? EMPTY_PROPS : _ref7$subTitleProps,
      hintTitle = _ref7.hintTitle,
      _ref7$hintLines = _ref7.hintLines,
      hintLines = _ref7$hintLines === void 0 ? 0 : _ref7$hintLines,
      _ref7$hintProps = _ref7.hintProps,
      hintProps = _ref7$hintProps === void 0 ? EMPTY_PROPS : _ref7$hintProps,
      helperTitle = _ref7.helperTitle,
      _ref7$helperLines = _ref7.helperLines,
      helperLines = _ref7$helperLines === void 0 ? 0 : _ref7$helperLines,
      _ref7$helperProps = _ref7.helperProps,
      helperProps = _ref7$helperProps === void 0 ? EMPTY_PROPS : _ref7$helperProps,
      props = _objectWithoutPropertiesLoose(_ref7, ["textAlign", "withOverflowHidden", "fullWidth", "fixedHeight", "size", "bodyTitle", "bodyIcon", "bodyLines", "bodyProps", "titleLines", "title", "titleProps", "titleAs", "kickerTitle", "kickerProps", "kickerPrefix", "kickerSuffix", "kickerColor", "kickerAs", "subTitle", "subTitleProps", "hintTitle", "hintLines", "hintProps", "helperTitle", "helperLines", "helperProps"]);

  return /*#__PURE__*/React.createElement(ContentWrapper, _extends({
    $withOverflowHidden: withOverflowHidden,
    $fullWidth: fullWidth,
    $size: size
  }, props), /*#__PURE__*/React.createElement(InfoContentSimple, {
    component: H5,
    lines: 1,
    fixedHeight: false,
    props: kickerProps,
    textAlign: textAlign,
    title: kickerTitle,
    prefix: kickerPrefix,
    suffix: kickerSuffix,
    color: kickerColor,
    as: kickerAs
  }), /*#__PURE__*/React.createElement(InfoContentSimple, {
    component: Big,
    textAlign: textAlign,
    fixedHeight: fixedHeight,
    props: titleProps,
    lines: titleLines,
    title: title,
    as: titleAs,
    strong: true
  }), /*#__PURE__*/React.createElement(InfoContentWithIconSimple, {
    component: Base,
    textAlign: textAlign,
    fixedHeight: fixedHeight,
    iconMargin: INFO_WITH_ICONS_SMALL_MARGIN,
    iconSize: ICON_SIZE,
    iconColor: ELEMENT_GRAY,
    icon: bodyIcon,
    lines: bodyLines,
    title: bodyTitle,
    props: bodyProps
  }), /*#__PURE__*/React.createElement(InfoContentSimple, {
    component: Small,
    textAlign: textAlign,
    lines: 1,
    fixedHeight: false,
    props: subTitleProps,
    title: subTitle,
    muted: true
  }), /*#__PURE__*/React.createElement(InfoContentSimple, {
    component: Small,
    textAlign: textAlign,
    fixedHeight: fixedHeight,
    props: hintProps,
    lines: hintLines,
    title: hintTitle
  }), /*#__PURE__*/React.createElement(InfoContentSimple, {
    component: ExtraSmall,
    textAlign: textAlign,
    fixedHeight: fixedHeight,
    props: helperProps,
    lines: helperLines,
    title: helperTitle
  }));
};

export default InfoCardContent;